import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import LevelOfEducationDummyRepository
  from '@/modules/onboarding/catalogs/level-of-education/infrastructure/repository/level-of-education-dummy-repository/level-of-education-dummy-repository';
import LevelOfEducationHttpRepository
  from './infrastructure/repository/level-of-education-http-repository';
import VueStateManager from './infrastructure/state/vue-state-manager';

// Application
import GetAllLevelOfEducationQuery from './application/queries/get-all-level-of-education-query';

// Domain
import { LevelOfEducationRepository } from './domain/repositories/level-of-education-repository';
import { StateManager } from './domain/state/state-manager';

export default function setupLevelOfEducation(container: Container) {
  const with_dummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<StateManager>(TYPES.LEVEL_OF_EDUCATION_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<LevelOfEducationRepository>(TYPES.LEVEL_OF_EDUCATION_REPOSITORY)
    .to(
      with_dummies
        ? LevelOfEducationDummyRepository
        : LevelOfEducationHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<GetAllLevelOfEducationQuery>(TYPES.GET_ALL_LEVEL_OF_EDUCATION_QUERY)
    .to(GetAllLevelOfEducationQuery)
    .inSingletonScope();
}
